import store from '../store'
import { eventType, jsonConfigTemplate } from './constants'
import {
  emitEventToParentWindow,
  isUserLoggedIn,
  getTranslation
} from './utils'
import { chatWidgetScreenSizes } from './constants'
import Storage from './storageLib'
import AppWarn from './errors/app-warns'

export const handleQuickReplySend = async (index) => {
  try {
    store.dispatch('setIsCalloutBubbleEnabled', false)
    store.dispatch('toggleChatWindowStatus', !store.state.isWindowMaximized)
    store.dispatch('updateQuickReplyOptions', [])
    isUserLoggedIn() && (await store.dispatch('fetchHistory'))
    store.dispatch('sendQuickReplyMessage', {
      userMessage: {
        payload: getTranslation(
          `${jsonConfigTemplate.CALLOUT_BUBBLE_OPTIONS_METADATA}${index + 1}`
        ),
        label: getTranslation(
          `${jsonConfigTemplate.CALLOUT_BUBBLE_OPTIONS_LABEL}${index + 1}`
        )
      }
    })
  } catch (error) {
    console.log('Error Sending Quick Reply Bubble Message', error.message)
    new AppWarn({
      message: 'Error Sending Quick Reply Bubble Message',
      err: error
    })
  }
}

export const handleQuickReplyBubbleClick = (quickReply) => {
  Storage.setSessionStorageData('userInteracted', true)
  // Resize CW first and handle send in next tick (repainting issues in chrome)
  emitEventToParentWindow(
    eventType.UPDATE_PARENT_WINDOW_STYLE,
    chatWidgetScreenSizes.LARGE_SCREEN_DEVICES
  )
  let timeoutId = setTimeout(() => {
    handleQuickReplySend(quickReply)
    clearTimeout(timeoutId)
  }, 0)
}

export const handleTextBubbleSend = async () => {
  try {
    store.dispatch('setIsCalloutBubbleEnabled', false)
    store.dispatch('toggleChatWindowStatus', !store.state.isWindowMaximized)
    isUserLoggedIn() && (await store.dispatch('fetchHistory'))
    store.state?.widgetConfig?.proActiveGreetings
      ? store.dispatch('triggerProActiveGreetings')
      : store.dispatch('triggerCalloutBubbleGreetings')
  } catch (error) {
    console.log('Error Sending Text Callout Bubble Message', error.message)
    new AppWarn({
      message: 'Error Sending Text Callout Bubble Message',
      err: error
    })
  }
}

export const handleTextBubbleClick = () => {
  Storage.setSessionStorageData('userInteracted', true)
  // Resize CW first and handle send in next tick (repainting issues in chrome)
  emitEventToParentWindow(
    eventType.UPDATE_PARENT_WINDOW_STYLE,
    chatWidgetScreenSizes.LARGE_SCREEN_DEVICES
  )
  let timeoutId = setTimeout(() => {
    handleTextBubbleSend()
    clearTimeout(timeoutId)
  }, 0)
}
